
export const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#A2C1C2',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
}


const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4']
}

export const PRIMARY = {
  lighter: '#C8FACD',
  light: '#EC7846',
  main: '#E24D28',
  dark: '#007B55',
  darker: '#005249',
  contrastText: '#fff',
  link: '#264653',
  header: '#264653',
  newBg: '#EDE7DE'
};

export const SECONDARY = {
  lighter: '#D6E4FF',
  light: '#84ADAE',
  main: '#EDE7DE',
  dark: '#A2C1C2',
  darker: '#BDBDBD',
  contrastText: '#fff',
  buttons: '#264653'
};

export const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#E24D28',
  dark: '#E24D28',
  darker: '#C42704'
}
export const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D'
}
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01'
}
export const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#E24D28',
  dark: '#B72136',
  darker: '#B72136'
}

// NAB Theme colors
export const NABPRIMARY = {
  lighter: '#c20000',
  light: '#c20000',
  main: '#c20000',
  dark: '#8b0000',
  darker: '#660000',
  contrastText: '#fff'
};

export const NABSECONDARY = {
  lighter: '#000000',
  light: '#333333',
  main: '#000000',
  dark: '#000000',
  darker: '#000000',
  contrastText: '#fff'
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  grey: GREY,
  chart: CHART_COLORS,
  divider: GREY[400],
  action: {
    hover: GREY[200],
    selected: GREY[300],
    disabled: GREY[500],
    disabledBackground: GREY[100],
    focus: GREY[200],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
};

export const NABINFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#000000',
  dark: '#000000',
  darker: '#000000',
  contrastText: '#fff'
};

const palette = {
  light: {
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    background: { paper: '#fff', default: '#f4f6f8' },
    text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
    action: { active: GREY[600], ...COMMON.action }
  },
  nab: {
    primary: NABPRIMARY,
    secondary: NABSECONDARY,
    info: NABINFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    background: { paper: GREY[800], default: GREY[900] },
    text: { primary: '#fff', secondary: GREY[500], disabled: GREY[600] },
    action: { active: GREY[500], ...COMMON.action }
  }
};

export default palette;
